import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {IdentityConstants} from '../../services/identity.constants';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  isAdmin = false;
  isSafetyManager = false;
  isTerminalManager = false;
  isOrgManager = false;
  isDriver = false;
  orgIdParam = '';

  constructor (private authenticationService: AuthenticationService) {
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit(): void {
    const me = this;
    this.authenticationService.userChanged().subscribe(user => {
      me.isAdmin = me.authenticationService.isInRole(IdentityConstants.AdminRoleName);
      me.isSafetyManager = me.authenticationService.isInRole(IdentityConstants.SafetyManagerRoleName);
      me.isTerminalManager = me.authenticationService.isInRole(IdentityConstants.TerminalManagerRoleName);
      me.isOrgManager = me.authenticationService.isInRole(IdentityConstants.OrgManagerRoleName);
      me.isDriver = me.authenticationService.isInRole(IdentityConstants.DriverRoleName);
      me.orgIdParam = me.formatOrgId (user?.organizationId);
    });
  }

  formatOrgId(orgId: any): string {
    if (orgId) {
      return '/' + orgId.toString();
    }
    return '';
  }
}
